<template>
  <div class="animated fadeIn">
    <b-card-body class="m-0 pt-0" id="areaImprimir">
      <div class="text-center">
        <b-spinner v-if="!dataReport" label="Spinning"></b-spinner>
      </div>
      <b-row class="border-bottom mb-2">
        <b-col>
          <b-img
            :src="img"
            left
            fluid
            style="max-height: 100px"
            alt="Responsive image"
            class="rounded pb-0"
          ></b-img>
          <h1 class="text-right">
            GUÍA EXPORTACIÓN #{{ dataReport.waybill_data.number }}
          </h1>
          <h4 class="text-right">
            Instructivo de Embarque #{{
              dataReport.waybill_data_export_waybill.shipment.boarding_number
            }}
          </h4>
          <h4 class="text-right">
            {{
              dataReport.waybill_data_export_waybill.shipment.shipment_type.name
            }}
          </h4>

          <p class="text-right"></p>
          <a href="#" class="float-right text-black-50" @click="descargarPDF"
            ><i class="fa fa-download"></i
          ></a>
        </b-col>
      </b-row>
      <br />
      <b-row class="mb-4">
        <b-col sm="4">
          <h6 class="mb-3">Destinatario:</h6>
          <div>
            <strong>{{ dataReport.waybill_data.company.company_name }}</strong>
          </div>
          <div>{{ dataReport.waybill_data.company.company_number }}</div>
          <div>{{ dataReport.waybill_data.company.address1 }}</div>
          <div>{{ dataReport.waybill_data.company.address2 }}</div>
          <div>Email: {{ dataReport.waybill_data.company.email }}</div>
          <div>Teléfono: {{ dataReport.waybill_data.company.phone }}</div>
        </b-col>
        <b-col sm="4">
          <h6 class="mb-3">Exportadora Solicitante:</h6>
          <div>
            <strong>{{
              dataReport.waybill_data.client_customer.company_name
            }}</strong>
          </div>
          <div>
            {{ dataReport.waybill_data.client_customer.company_number }}
          </div>
          <div>{{ dataReport.waybill_data.client_customer.address1 }}</div>
          <div>{{ dataReport.waybill_data.client_customer.address2 }}</div>
          <div>Email: {{ dataReport.waybill_data.client_customer.email }}</div>
          <div>
            Teléfono: {{ dataReport.waybill_data.client_customer.phone }}
          </div>
        </b-col>
        <b-col sm="4">
          <h6 class="mb-3">Detalles:</h6>
          <div>
            Fecha de guía de despacho:
            {{ dataReport.waybill_data.waybill_date }}
          </div>
          <div>
            Tara total del camion:
            {{ dataReport.waybill_data_export_waybill.vgm }}
          </div>
          <div>
            Planilla SAG: {{ dataReport.waybill_data_export_waybill.sag_sheet }}
          </div>
          <div>
            Contraparte SAG:
            {{
              dataReport.waybill_data_export_waybill.sag_worker.get_full_name
            }}
          </div>
          <div>Chofer: {{ dataReport.waybill_data.truck_driver }}</div>
          <div>Patente: {{ dataReport.waybill_data.license_plate }}</div>
        </b-col>
      </b-row>

      <h6 class="mb-2 font-weight-bold">Pallets:</h6>
      <div class="table-responsive-sm">
        <table class="table table-sm">
          <thead>
            <tr class="font-weight-bold text-uppercase">
              <th class="text-center">#</th>
              <th class="text-center align-middle">Pallet</th>
              <th class="text-center align-middle">Variedad</th>
              <th class="text-center align-middle">Formato</th>
              <th class="text-center">Cantidad</th>
              <th class="text-right align-middle">Kg Netos</th>
              <th class="text-center align-middle">Huerto</th>
              <th class="text-right align-middle">Peso Bruto pallet</th>
              <th class="text-center align-middle">Temperatura</th>
              <th class="text-center align-middle">Posición</th>
              <th class="text-center align-middle">Termógrafo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(pallet, index) in dataReport.pallets_waybill">
              <td class="text-center align-middle">{{ index + 1 }}</td>
              <td class="text-center align-middle">
                {{ pallet.number }}
              </td>
              <td class="text-center align-middle">{{ pallet.varieties }}</td>
              <td class="text-center align-middle">{{ pallet.container }}</td>
              <td class="text-center">{{ pallet.total_quantity }}</td>
              <td class="text-right align-middle">
                {{ pallet.total_net_kilograms }}
              </td>
              <td class="text-center align-middle">{{ pallet.origins }}</td>
              <td class="text-right align-middle">
                {{ pallet.export_info.gross_weight }}
              </td>
              <td class="text-center align-middle">
                {{ pallet.export_info.temperature }}
              </td>
              <td class="text-center align-middle">
                {{ pallet.export_info.position }}
              </td>
              <td class="text-center align-middle">
                {{ pallet.export_info.temperature_recorder }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="font-weight-bold">
              <td class="text-center"></td>
              <td class="text-center"></td>
              <td class="text-center"></td>
              <td class="text-center">TOTALES</td>
              <td class="text-center">{{ totalQuantity }}</td>
              <td class="text-right">{{ totalKN | decimal }} Kg</td>
              <td class="left"></td>
              <td class="text-right">{{ totalKB | decimal }} Kg</td>
              <td class="left"></td>
              <td class="left"></td>
              <td class="left"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <hr />
      <p class="small text-center">
        {{ dataReport.waybill_data.note }}
      </p>
    </b-card-body>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";
import numeral from "numeral";

export default {
  name: "Reporte Guia exportacion",
  created() {},
  props: ["dataReport"],
  data() {
    return {
      img: "",
      client: null
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
    decimal(value) {
      return numeral(value).format("0,0.00");
    }
  },
  mounted() {
    this.img = localStorage.getItem("img");
    this.client = this.$store.getters.user.ID_CLIENTE;
  },
  methods: {
    descargarPDF: function () {
      var element = document.getElementById("areaImprimir").innerHTML;

      var opt = {
        margin: 0.25,
        image: { type: "jpeg", quality: 0.99 },
        html2canvas: { scale: 2, dpi: 192, letterRendering: true },
        filename:
          "Guia Exportcion #" + this.dataReport.waybill_data.number + ".pdf",
        jsPDF: { unit: "in", format: "letter", orientation: "landscape" }
      };
      html2pdf().from(element).set(opt).save();
    }
  },
  computed: {
    totalQuantity() {
      return this.dataReport.pallets_waybill.reduce(
        (total, item) => total + item.total_quantity,
        0
      );
    },
    totalKN() {
      return this.dataReport.pallets_waybill.reduce(
        (total, item) => total + parseFloat(item.total_net_kilograms),
        0
      );
    },
    totalKB() {
      return this.dataReport.pallets_waybill.reduce(
        (total, item) => total + parseFloat(item.export_info.gross_weight),
        0
      );
    }
  },
  beforeMount() {}
};
</script>

<style scoped>
.table-sm th,
.table-sm td {
  padding: 0.15rem;
}
</style>
